module.exports = __webpack_public_path__ + "img/person.37ce2954.svg";